import React from 'react';
function GapVertical({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M21.005 3.005L20.205 3.005C19.0849 3.005 18.5248 3.005 18.097 3.22299C17.7207 3.41474 17.4147 3.7207 17.223 4.09702C17.005 4.52485 17.005 5.0849 17.005 6.205L17.005 17.805C17.005 18.9251 17.005 19.4852 17.223 19.913C17.4147 20.2893 17.7207 20.5953 18.097 20.787C18.5248 21.005 19.0849 21.005 20.205 21.005L21.005 21.005M3.005 3.005L3.805 3.005C4.92511 3.005 5.48516 3.005 5.91299 3.22299C6.28931 3.41474 6.59527 3.7207 6.78702 4.09702C7.005 4.52485 7.005 5.0849 7.005 6.205L7.005 17.805C7.005 18.9251 7.005 19.4852 6.78702 19.913C6.59527 20.2893 6.28931 20.5953 5.91299 20.787C5.48516 21.005 4.92511 21.005 3.80501 21.005L3.005 21.005M12 6.5L12 18"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default GapVertical;
